import React from 'react';
import {Trans} from '@lingui/macro';
import {HelpAnywhereLoaderRingIcon} from '@apothecary/community-icons';
import PropTypes from 'prop-types';

import './LoadingSpinner.scss';

const LoadingSpinner = (props) => {
  return (
    <div
      data-testid="loading-spinner"
      className={`loading-gif${
        props.inShortForm ? ' loading-gif--short-form' : ''
      }`}
    >
      <div className="loading-gif__spinner">
        <HelpAnywhereLoaderRingIcon color="#666" />
      </div>
      <div className="loading-gif__text" data-testid="loading-message">
        {props.message ? props.message : <Trans>Working on it...</Trans>}
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  message: PropTypes.string,
  inShortForm: PropTypes.bool,
};

export default LoadingSpinner;
